import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  applyThemePreference,
  browserThemeStorage,
  nextThemePreference,
  readThemePreference,
  storeThemePreference,
  type ThemePreference,
} from '../../lib/theme';
import styles from './SiteHeader.module.css';

const ICONS: Record<ThemePreference, React.ReactNode> = {
  system: (
    <>
      <rect x="3" y="4" width="18" height="12" rx="2" />
      <path d="M8 20h8M12 16v4" />
    </>
  ),
  light: (
    <>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
    </>
  ),
  dark: <path d="M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5z" />,
};

export default function ThemeToggle() {
  const { t } = useTranslation();
  const [pref, setPref] = useState<ThemePreference>(() => readThemePreference(browserThemeStorage()));

  useEffect(() => {
    applyThemePreference(document.documentElement, pref);
  }, [pref]);

  function onClick() {
    const next = nextThemePreference(pref);
    storeThemePreference(browserThemeStorage(), next);
    setPref(next);
  }

  const label = t('theme.toggle', { current: t(`theme.${pref}`), next: t(`theme.${nextThemePreference(pref)}`) });
  return (
    <button type="button" className={styles.themeToggle} onClick={onClick} aria-label={label} title={label}>
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        {ICONS[pref]}
      </svg>
    </button>
  );
}
